<div class="modal-header">
  <h4 class="modal-title">
    {{ "Export acquisitions to CSV" | translate }}
  </h4>
  <button (click)="modal.dismiss()" class="btn-close" aria-label="Close" type="button"></button>
</div>

<div class="modal-body">
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{ "Loading..." | translate }}</span>
    </div>
    <div class="mt-2">
      {{ "Generating CSV data..." | translate }}
    </div>
  </div>

  <div *ngIf="!loading">
    <p class="text-muted mb-3">
      {{
        "Your acquisition data has been converted to CSV format. You can copy it to your clipboard using the button below."
          | translate
      }}
    </p>

    <div class="form-group">
      <label class="form-label" for="csvTextArea"> {{ "CSV Data" | translate }}: </label>
      <textarea
        [value]="csvContent"
        id="csvTextArea"
        class="form-control font-monospace"
        readonly
        rows="12"
        style="font-size: 0.875rem"
      ></textarea>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button (click)="modal.dismiss()" class="btn btn-secondary" type="button">
    {{ "Close" | translate }}
  </button>
  <button [disabled]="loading" (click)="onCopyToClipboard()" class="btn btn-primary" type="button">
    <fa-icon [icon]="['fas', 'copy']" class="me-2"></fa-icon>
    {{ "Copy to clipboard" | translate }}
  </button>
</div>
